













import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {computed, defineComponent, reactive, ref, watch} from "@vue/composition-api"
import {buildQueryDownloadUrl, executeQuery} from "@/data/repos/query"
import {bus} from "@/main"
import {getAppraisalCaption, getLocationCaption} from "@/data/sources/appraisal"
import {extractAppraisalItem, getAppraisalLastElementName} from "@/data/repos/appraisal"
import {colourToHex} from "@/data/sources/colour"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.KeyValue(),
    widget: "AppraisalResidualRisk",
    title: "Appraisal residual risk",
    _description: "The residual risk chart widget allows users to view the summary of residual risks for a survey.",
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
      appraisalEntity: {...WParamTpl.Appraisal(), _order: 2},
    },
  }
}

function getChartConfig() {
  return reactive(FCConfTpl())
}

function getChartDataConfig() {
  return reactive({
      ...ChartDataTemplate(),
      theme: "micad",
    },
  )
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    FusionChartWidget,
  },
  setup(props, context) {
    const errorMessage = ref("")
    context.emit("config-update", config())

    async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
      if (config) {
        chartDataConfig.subCaption =
            "Location: " + await getLocationCaption(config.params.locationId) + "<br>" +
            "Appraisal: " + getAppraisalCaption(config.params.appraisalEntity)
      }
    }

    function dataplotClickCallback(label: string, val: any) {
      const params = props.config && props.config.params
      showDrillDown(label, val, params)
    }

    const downloadUrl = computed(() => {
      const params = props.config && props.config.params
      const risk = extractAppraisalItem(params.appraisalEntity)
      if (!risk) {
        return null
      }
      const queryName = risk.subelementId ? "appraisal.residual_risk.residualRiskDrillDown_subelement" :
        risk.elementId ? "appraisal.residual_risk.residualRiskDrillDown_element" :
          risk.categoryId ? "appraisal.residual_risk.residualRiskDrillDown_category" :
            risk.facetId ? "appraisal.residual_risk.residualRiskDrillDown_facet" :
              risk.surveyId ? "appraisal.residual_risk.residualRiskDrillDown_survey" : null
      const args: any = risk.subelementId ? {subelementId: risk.subelementId} :
        risk.elementId ? {elementId: risk.elementId} :
          risk.categoryId ? {categoryId: risk.categoryId} :
            risk.facetId ? {facetId: risk.facetId} :
              risk.surveyId ? {surveyId: risk.surveyId} : null
      args.locationId = parseInt(params.locationId.value)
      return queryName ? buildQueryDownloadUrl("idr", queryName, args) : null
    })

    async function dataFetcher(params: any): Promise<{ data: any[] | null }> {
      if (!params.appraisalEntity.value.survey || !params.appraisalEntity.value.survey.value) {
        errorMessage.value = "Please configure Survey"
        return {data: []}
      }
      errorMessage.value = ""
      const item = extractAppraisalItem(params.appraisalEntity)
      const elementName = item ? getAppraisalLastElementName(item) : null
      if (item && elementName) {
        return {
          data: await executeQuery(
            "idr", "appraisal.residual_risk.residualRisk_" + elementName, {
              locationId: parseInt(params.locationId.value),
              surveyId: item.surveyId,
              facetId: item.facetId,
              categoryId: item.categoryId,
              elementId: item.elementId,
              subelementId: item.subelementId,
            },
            convert),
        }
      } else {
        return {data: []}
      }

      function convert(data: any[]): any[] {
        return data.map(item => {
          const d = {
            label: item.riskLabel,
            value: item.CountOfRisk,
            color: colourToHex(item.riskColour),
          }
          return d
        })
      }
    }

    return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback, downloadUrl, errorMessage}
  },
})

function showDrillDown(label: string, val: any, params: any) {
  bus.$emit("modalBoxCreate", {
    component: drillDown,
    componentArgs: {
      locationId: params.locationId.value,
      risk: extractAppraisalItem(params.appraisalEntity),
    },
  })
}

const drillDown = () => ({
  component: import("@/components/widgets/appraisal/AppraisalResidualRiskDrillDown.vue"),
  delay: 200,
  timeout: 3000,
})
